import React from 'react';
import { Input } from 'antd';
import { asserts } from '../../../utils';

export default React.forwardRef(({ value, onChange, onBlur, style, ...rest }, ref) => {
  const handleChange = (e) => {
    const { value } = e.target;
    //console.log(value);
    const reg = /^[1-9]\d*$/;
    if ((!isNaN(value) && reg.test(value)) || value === '') {
      asserts.isFunction(onChange) && onChange(value);
    }
  };

  const handleBlur = () => {
    const val = value + '';
    if (val.charAt(val.length - 1) === '.' || val === '-') {
      onChange(val.slice(0, -1));
    }
    if (onBlur) {
      asserts.isFunction(onBlur) && onBlur();
    }
  };

  return (
    <Input
      {...rest}
      style={style}
      value={value}
      ref={ref}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
});
